import { Map, List } from "immutable";

import {
    CASE_TYPES,
    STATE_STATUS,
    CASE_ACTIONS,
    STAGE_CASE_ACTIONS,
    STAGE_ACTIONS
} from "constants";

const INTIAL_STATE = CASE_TYPES.map(
    () =>
        new Map({
            data: new Map({}),
            status: STATE_STATUS.UNFETCHED
        })
);

export default (state = INTIAL_STATE, { type, payload }) => {
    switch (type) {
    case STAGE_ACTIONS.FETCHED_STAGES_LIST:
        return state.map(_ => {
            return _.set(
                "data",
                new List(payload.stageList)
                    .toMap()
                    .mapEntries(([, V]) => [V.stage_name, 0])
            );
        });
    case CASE_ACTIONS.FETCH_CASES_COUNT:
        return state.map(_ => _.set("status", STATE_STATUS.FETCHING));
    case CASE_ACTIONS.FETCHED_CASES_COUNT:
        return state.map((_, k) =>
            _.withMutations(map => {
                map.set("data", map.get("data").map(() => 0));
                payload.count[k].map(obj =>
                    map.setIn(
                        ["data", obj["this_stage__stage_name"]],
                        obj.count
                    )
                );
                map.set("status", STATE_STATUS.FETCHED);
                return map;
            })
        );
    case CASE_ACTIONS.FAILED_FETCH_CASES_COUNT:
        return state.setIn(
            [payload.caseStatus, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case STAGE_CASE_ACTIONS.FETCHED_STAGE_CASE_COUNT:
        return state.setIn([payload.type, payload.stage], payload.count);
    case "LOGOUT":
        return INTIAL_STATE;
    default:
        return state;
    }
};
